export default __webpack_public_path__ + "static/media/People24x24.682eb54b.svg";